import React, {Component} from 'react'
import {Button, Collapse} from 'reactstrap'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import PropTypes from 'prop-types'
import {Mutation} from 'react-apollo'
import {toast} from 'react-toastify'

import CommunicationMethodInput from "../communication_method/CommunicationMethodInput";
import ClientCommunicationMethodsList from "./ClientCommunicationMethodsList";

import upsertClientCommunicationMethodsMutation
    from '../../../queries/server/mutations/upsert_client_communication_method'
import editClientLocalMutation from '../../../queries/client_side/mutations/edit_client'

class ClientCommunicationMethods extends Component {

    state = {
        showInput: false,
        newCommunicationMethod: {
            contact_medium_id: '',
            contact_info: ''
        }
    }

    reset = () => {
        this.setState({
            newCommunicationMethod: {
                contact_medium_id: '',
                contact_info: ''
            }
        })
    }

    closeInput = () => {
        this.setState({showInput: false})
    }

    render() {

        const {state} = this
        const {communicationMethods, client_id} = this.props
        const {newCommunicationMethod: {contact_medium_id, contact_info}} = state

        return (
            <div>
                <Button
                    size="sm"
                    color={state.showInput ? 'warning' : 'success'}
                    onClick={() => this.setState({showInput: !state.showInput})}
                >
                    <FontAwesomeIcon color="#fff" icon={state.showInput ? 'minus' : 'plus'}/>{' '}
                    {state.showInput ? 'Cancel' : 'Add Communication Method'}
                </Button>

                <Collapse isOpen={state.showInput}>
                    <div className="d-flex flex-column pt-3 mt-3 card card-body bg-light">
                        <Mutation mutation={upsertClientCommunicationMethodsMutation}>
                            {(upsertClientCommunicationMethodsMutationFunc, {loading}) => (
                                <Mutation mutation={editClientLocalMutation}>
                                    {(editClientLocalMutationFunc) => (
                                        <CommunicationMethodInput
                                            contact_info={contact_info}
                                            contact_medium_id={contact_medium_id}
                                            saving={loading}
                                            onContactInfoChanged={(value) => this.setState({
                                                newCommunicationMethod: {
                                                    ...state.newCommunicationMethod,
                                                    contact_info: value
                                                }
                                            })}
                                            onContactMediumChanged={(value) => this.setState({
                                                newCommunicationMethod: {
                                                    ...state.newCommunicationMethod,
                                                    contact_medium_id: value
                                                }
                                            })}

                                            onCancel={() => {
                                                this.reset()
                                                this.closeInput()
                                            }}

                                            onSave={() => {
                                                upsertClientCommunicationMethodsMutationFunc({
                                                    variables: {
                                                        client_id,
                                                        data: [{contact_medium_id, contact_info}]
                                                    }
                                                })
                                                    .then(({data}) => {
                                                        editClientLocalMutationFunc({variables: {data: data.upsertClientCommunicationMethod}})
                                                        toast.success('Communication Method Added', {autoClose: 2000})
                                                        this.reset()
                                                        this.closeInput()
                                                    })
                                                    .catch(e => toast.error(e.message, {autoClose: false}))
                                            }}
                                        />
                                    )}

                                </Mutation>
                            )}

                        </Mutation>
                    </div>
                </Collapse>


                <ClientCommunicationMethodsList
                    client_id={client_id}
                    communicationMethods={communicationMethods}/>
            </div>
        )

    }

}

ClientCommunicationMethods.propTypes = {
    client_id: PropTypes.number.isRequired,
    communicationMethods: PropTypes.array.isRequired
}

export default ClientCommunicationMethods